<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'

const props = defineProps({
    active: {
        type: Boolean,
        default: false
    },
    label: {
        type: String,
        required: true
    },
    link: {
        type: String,
        required: false
    },
    obfuscated: {
        type: Boolean,
        default: false
    },
    small: {
        type: Boolean,
        default: false
    }
})

const router = useRouter()
const loaded = ref(false)

const buttonRef = ref(null)
const obfuscatedRef = ref(null)

function obfuscateLink(link) {
    if (obfuscatedRef.value && link) {
        obfuscatedRef.value.addEventListener('click', () => {
            router.push({ path: link })
        })
    }
}



onMounted(() => {
    loaded.value = true
    if (props.obfuscated) {
        obfuscateLink(props.link)
    }
    const button = buttonRef.value
    
    if (!button ) return

})


</script>


<template>
    <div :class="`outline-button ${props.small ? 'outline-button--small' : ''}`">
        <router-link :to="props.link" v-if="!props.obfuscated && props.link">
            <div :class="{ active: props.active }">
                {{ props.label }}
            </div>
        </router-link>
        <div v-else :class="{ active: props.active }" class="obfuscated" ref="obfuscatedRef">
            {{ props.label }}
        </div>
    </div>
</template>



<style lang="scss" scoped>

.outline-button{
    all: unset;
    position: relative;
    background: rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(2px);
    color: white;
    border-radius: 50px;
    padding: 0;
    box-sizing: border-box;
    transition: filter 0.3s ease-in-out;
    cursor: pointer;

    &:hover {
        &:before,
        & a > div,
        & .obfuscated {
            filter: brightness(2);
        }
    }

    &:before {
        content: '';
        position: absolute;
        z-index: -1;
        inset: 0px;
        
        border-radius: inherit;
        /* this is the border width */
        padding: 2px;
        -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
        mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask-composite: exclude;
    }

    &:before,
    & a > div,
    & .obfuscated {
        @include animated-background-gradient;
        transition: filter .35s ease-in-out;
    }

    & a > div,
    & .obfuscated {
        font-family: $secondary-font-family;
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 0.7px;
        text-transform: uppercase;
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        padding: 13px 70px;
    }    

    &--small{
        & a > div,
        & .obfuscated {
            padding: 8px 70px;
        }
    }

}
</style>